import axios from "axios";
import { adminClient } from "./admin";

const BASE = process.env.REACT_APP_BACKEND_URL;
const publicClient = axios.create({ baseURL: `${BASE}/api` });

// ---- Public (no auth) ----
export const fetchLibraryMaterials = async (category) => {
  const params = category && category !== "All" ? { category } : {};
  return (await publicClient.get(`/library/materials`, { params })).data;
};
export const fetchLibraryMaterial = async (id) =>
  (await publicClient.get(`/library/materials/${id}`)).data;

// ---- Admin ----
export const adminListLibraryMaterials = async () =>
  (await adminClient().get(`/admin/library/materials`)).data;

export const adminCreateLibraryMaterial = async (body) =>
  (await adminClient().post(`/admin/library/materials`, body)).data;

export const adminUpdateLibraryMaterial = async (id, body) =>
  (await adminClient().patch(`/admin/library/materials/${id}`, body)).data;

export const adminDeleteLibraryMaterial = async (id) =>
  (await adminClient().delete(`/admin/library/materials/${id}`)).data;

export const adminUploadLibraryImage = async (id, file, opts = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  if (opts.caption != null) fd.append("caption", opts.caption);
  if (opts.replace_index != null) fd.append("replace_index", String(opts.replace_index));
  return (await adminClient().post(`/admin/library/materials/${id}/upload-image`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;
};

export const adminGenerateLibraryImage = async (id, body = {}) =>
  (await adminClient().post(`/admin/library/materials/${id}/generate-image`, body)).data;

export const adminDeleteLibraryImage = async (id, idx) =>
  (await adminClient().delete(`/admin/library/materials/${id}/images/${idx}`)).data;

export const adminPatchLibraryImage = async (id, idx, body) =>
  (await adminClient().patch(`/admin/library/materials/${id}/images/${idx}`, body)).data;

export const adminReorderLibraryImages = async (id, order) =>
  (await adminClient().post(`/admin/library/materials/${id}/images/reorder`, { order })).data;
